/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {ChangeOwnerRequest} from '@cash-web/protos/squareup/roster/mds.pb'
import {ChangeOwnerResponse} from '@cash-web/protos/squareup/roster/mds.pb'


export const changeOwner = (request: ChangeOwnerRequest, options?: CashRequestOptions) => post<ChangeOwnerRequest, ChangeOwnerResponse>("/2.0/cash/change-owner", request, {...options, rejectOnError: true })